import { NAME } from './reducer'

const getReducerState = state => state[NAME]
export const getUser = state => getReducerState(state).user
export const getPreferences = state => getReducerState(state).preferences
